var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.417,
    height: 24.865,
    viewBox: "0 0 28.417 24.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4340",
    "data-name": "Trazado 4340",
    d: "M2.888,8.776A.888.888,0,1,0,2,7.888a.888.888,0,0,0,.888.888",
    transform: "translate(1.552 4.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4341",
    "data-name": "Trazado 4341",
    d: "M8.88,1A3.552,3.552,0,0,0,5.328,4.552V8.1H3.552A3.552,3.552,0,0,0,0,11.657v5.328a3.552,3.552,0,0,0,3.552,3.552H5.328v1.776A3.552,3.552,0,0,0,8.88,25.865H19.537a3.552,3.552,0,0,0,3.552-3.552V20.537h1.776a3.552,3.552,0,0,0,3.552-3.552V11.657A3.552,3.552,0,0,0,24.865,8.1H23.089V4.552A3.552,3.552,0,0,0,19.537,1ZM7.1,4.552A1.776,1.776,0,0,1,8.88,2.776H19.537a1.776,1.776,0,0,1,1.776,1.776V8.1H7.1Zm1.776,8.88a3.552,3.552,0,0,0-3.552,3.552v1.776H3.552a1.776,1.776,0,0,1-1.776-1.776V11.657A1.776,1.776,0,0,1,3.552,9.88H24.865a1.776,1.776,0,0,1,1.776,1.776v5.328a1.776,1.776,0,0,1-1.776,1.776H23.089V16.985a3.552,3.552,0,0,0-3.552-3.552Zm12.433,3.552v5.328a1.776,1.776,0,0,1-1.776,1.776H8.88A1.776,1.776,0,0,1,7.1,22.313V16.985A1.776,1.776,0,0,1,8.88,15.209H19.537a1.776,1.776,0,0,1,1.776,1.776",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.9aaf32e79d562532e8b6639d29b5b135.svg";
export { ForwardRef as ReactComponent };